import React from 'react';
import {
  createFrontendPlugin,
  ApiBlueprint,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/frontend-plugin-api';
import { compatWrapper } from '@backstage/core-compat-api';
import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';
import { isDefectDojoAvailable } from './utils/annotations';
import { defectDojoApiRef } from './api/DefectDojoApi';
import { DefectDojoClient } from './api/DefectDojoClient';

const defectDojoEntityContent = EntityContentBlueprint.make({
  name: 'defect-dojo',
  params: {
    path: '/defect-dojo',
    title: 'DefectDojo',
    filter: isDefectDojoAvailable,
    loader: async () =>
      import('./components/DefectDojoPage').then(m =>
        compatWrapper(React.createElement(m.DefectDojoPage)),
      ),
  },
});

const defectDojoApi = ApiBlueprint.make({
  name: 'defect-dojo',
  params: defineParams =>
    defineParams({
      api: defectDojoApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
      },
      factory: ({ discoveryApi, fetchApi }) =>
        new DefectDojoClient({ discoveryApi, fetchApi }),
    }),
});

const defectDojoPlugin = createFrontendPlugin({
  pluginId: 'defect-dojo',
  extensions: [defectDojoEntityContent, defectDojoApi],
});

export default defectDojoPlugin;
